import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 3,
  class: "fluid"
}
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "fluid"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "tiles fluid",
  ref: "tiles"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContributeLink = _resolveComponent("ContributeLink")!
  const _component_FavIcon = _resolveComponent("FavIcon")!
  const _component_FunSnow = _resolveComponent("FunSnow")!
  const _component_background = _resolveComponent("background")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_configuration_form = _resolveComponent("configuration-form")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_pipeline_tile_grid = _resolveComponent("pipeline-tile-grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ContributeLink),
    _createVNode(_component_FavIcon, { pipelines: _ctx.pipelines }, null, 8, ["pipelines"]),
    (_ctx.config.alpha_show_snow && _ctx.show_snow_fun)
      ? (_openBlock(), _createBlock(_component_FunSnow, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_background),
    (!_ctx.configuring)
      ? (_openBlock(), _createBlock(_component_b_button, {
          key: 1,
          class: "options",
          onClick: _ctx.openConfiguration,
          placement: "left",
          title: "Open options",
          "aria-label": "options"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" open options ")
          ])),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.configuring)
      ? (_openBlock(), _createBlock(_component_configuration_form, {
          key: 2,
          class: "configuration-form",
          onOnSubmit: _ctx.onSubmit,
          config: _ctx.config
        }, null, 8, ["onOnSubmit", "config"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.error), 1),
                _cache[2] || (_cache[2] = _createElementVNode("p", null, "The dashboard will automatically retry every 60 seconds.", -1)),
                _createVNode(_component_b_button, {
                  size: "lg",
                  variant: "outline-danger",
                  onClick: _ctx.retry
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Retry now ")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_loading_spinner)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_pipeline_tile_grid, {
                        pipelines: _ctx.pipelines,
                        group_by_groups: _ctx.config.group_by_groups,
                        group_by_namespaces: _ctx.config.group_by_namespaces,
                        show_history: _ctx.config.beta_show_history
                      }, null, 8, ["pipelines", "group_by_groups", "group_by_namespaces", "show_history"])
                    ], 512))
              ]))
        ]))
  ]))
}